/**
 * @toggle
 */
import {findAncestorByAttr, isWidthResize} from "../common/utils";
import {Resolutions} from "../common/const";

class Toggle {
    constructor(wrap) {
        this.wrap = wrap;
        this.btn = this.wrap.querySelector(`[data-toggle-btn]`);
        this.btnClose = this.wrap.querySelector(`[data-toggle-btn-close]`);
        this.block = this.wrap.querySelector(`[data-toggle-block]`);
        this.timeout = parseInt(this.wrap.getAttribute(`data-toggle-container`), 10);
        this.state = this.wrap.classList.contains(`opened`) ? `opened` : `closed`;
        this.isOnlyOneTab = this.wrap.hasAttribute(`data-toggle-only`);
        this.onResize = this.onResize.bind(this);
        this.openHideToggleBlock = this.openHideToggleBlock.bind(this);
        this.innerLinkClickHandler = this.innerLinkClickHandler.bind(this);
        this.HEADER_MOB_HEIGHT = 110;
        this.scrollbar = null;
        this.isDropdown = this.wrap.hasAttribute(`data-dropdown-scrollbar`);
        this.links = this.block.querySelectorAll(`[data-dropdown-value]`);
    }

    setState(state) {
        this.state = state;
    }

    addScrollbar() {
        if (this.isDropdown) {
            if (!this.scrollbar) {
                this.scrollbar = new window.SimpleBar(this.block, { autoHide: false });
            } else {

                this.recalculateScrollbar();
            }
        }
    }

    recalculateScrollbar() {
        if (this.scrollbar) this.scrollbar.recalculate();
    }

    hideToggleBlock() {
        $(this.block).slideUp(this.timeout);
        this.wrap.classList.remove(`opened`);
        this.recalculateScrollbar();
    }

    openHideToggleBlock() {
        if (this.wrap.classList.contains(`opened`)) {
            this.hideToggleBlock();
        } else {
            $(this.block).slideDown(this.timeout);
            this.wrap.classList.add(`opened`);
            this.addScrollbar();

            if (this.btn.getAttribute(`data-toggle-btn`) === `map-list`) {
                $(`[data-order-btn="list"]`).addClass(`active`);
                $(`[data-order-btn="map"]`).removeClass(`active`);
            }

            if (this.isOnlyOneTab) {
                for (let child of this.wrap.parentNode.children) {
                    if (child !== this.wrap) {
                        child.classList.remove(`opened`);
                        $(child).find(`[data-toggle-block]`).slideUp(this.timeout);
                    }
                }

                if (!this.wrap.hasAttribute(`data-dropdown`)) {
                    setTimeout(() => {
                        $(`html, body`).animate({
                            scrollTop: $(this.wrap).offset().top - this.HEADER_MOB_HEIGHT
                        });
                    }, this.timeout);
                }
            }
        }
    }

    onResize() {
        this.block.style.display = ``;
    }

    innerLinkClickHandler(e) {
        const input = this.wrap.querySelector(`[data-dropdown-input]`);
        if (input) {
            input.value = e.target.getAttribute(`data-dropdown-value`);
            input.dispatchEvent(new Event(`input`));
        }

        this.wrap.querySelectorAll(`[data-dropdown-value]`).forEach((link) => link.classList.remove(`active`));
        e.target.classList.add(`active`);
        // const btn = this.wrap.querySelector(`[data-toggle-btn]`);
        // if (btn) {
        //     btn.querySelector(`span`).textContent = e.target.getAttribute(`data-dropdown-value`);
        // }

        if (this.wrap.classList.contains(`dropdown--tab-only`)) {
            if (Resolutions.IS_TAB()) {
                this.hideToggleBlock();
            }
        } else {
            this.hideToggleBlock();
        }
    }

    init() {
        if (this.wrap.classList.contains(`opened`)) {
            this.block.style.display = `block`;
        }

        // клик по кнопке открывающей список
        this.btn.addEventListener(`click`, this.openHideToggleBlock);

        // клик по ссылкам внутри открывающего списка
        this.links.forEach((link) => {
            link.addEventListener(`click`, this.innerLinkClickHandler);
        });

        // нажатие на ESC
        document.addEventListener(`keydown`, (e) => {
            if (this.isDropdown && e.keyCode == 27) {
                this.hideToggleBlock();
            }
        });

        $(document).mouseup((e) => {
            if (this.isDropdown) {
                const div = $(this.wrap); // тут указываем ID элемента
                if ( !div.is(e.target) && div.has(e.target).length === 0 ) { // и не по его дочерним элементам
                    $(this.block).slideUp(this.timeout);
                    this.wrap.classList.remove(`opened`);
                    this.recalculateScrollbar();
                }
            }
        });

        if (this.btnClose) this.btnClose.addEventListener(`click`, this.openHideToggleBlock);

        isWidthResize(this.onResize);
    }

    refreshScripts() {
        this.addScrollbar();
    }
}

export const initToggle = () => {
    const blocks = document.querySelectorAll(`[data-toggle-container]`);
    if (!blocks.length) return;

    blocks.forEach(block => new Toggle(block).init());
}

export const refreshToggle = () => {
    const blocks = document.querySelectorAll(`[data-toggle-container]`);
    if (!blocks.length) return;

    blocks.forEach(block => new Toggle(block).refreshScripts());
}

window.initToggle = (block) => new Toggle(block).init();
window.refreshToggle = (block) => new Toggle(block).refreshScripts();
